// #region imports

// --- Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

// --- HS Code
import { routes } from './app.routing';

// #endregion

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules, enableTracing: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
